module.exports = __webpack_public_path__ + "img/s-hd.3d9c504c.jpg";